import { Modal } from 'antd';
import React from 'react';
import useHomeStore from "../../../../../store/homeStore";
import MikeNotificationGroups from "../../../../features/Notifications/MikeNotificationGroups";
import {renderNotificationTitle} from "../../../../features/Notifications/renders";

type PrivateProps = {
  visible: boolean;
  onHandleNotificationModalCancel: () => void;
};

export default function NotificationModal({
  visible,
  onHandleNotificationModalCancel,
}: PrivateProps) {
  const notifications = useHomeStore(state => state.notifications);

  return (
  <Modal
    open={visible}
    footer={null}
    onCancel={onHandleNotificationModalCancel}
    bodyStyle={{ overflowY: 'scroll' }}
  >
    <div>
      <MikeNotificationGroups
        notifications={notifications}
        renderTitle={renderNotificationTitle}
      />
    </div>
  </Modal>
  );
}
